import type { ComponentProps, ReactNode } from 'react'
import { type VariantProps } from 'tailwind-variants'

import { cn } from '@gto/ui/cn'

import { inputVariants } from './input.styles'
import { InputAddon } from './input-addon'

type InputGroupVariantProps = VariantProps<typeof inputVariants>

export type InputGroupProps = ComponentProps<'div'> &
  InputGroupVariantProps & {
    startAddon?: ReactNode
    endAddon?: ReactNode
  }

export const InputGroup = ({
  className,
  size,
  variant,
  startAddon = null,
  endAddon = null,
  children,
  ...props
}: InputGroupProps) => {
  const { root } = inputVariants({ size, variant })

  return (
    <div
      className={cn(root(), className)}
      {...props}
    >
      {startAddon !== null && <InputAddon data-slot="start-addon">{startAddon}</InputAddon>}
      {children}
      {endAddon !== null && <InputAddon data-slot="end-addon">{endAddon}</InputAddon>}
    </div>
  )
}
